export function getCurrentPath(): string {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

const INVITE_REDIRECT_PARAMS = ['invitation', 'organization'] as const;

export interface InviteRedirectParams {
  invitation: string;
  organization: string;
  prompt: 'login';
}

export function getInviteRedirectParams(): InviteRedirectParams | undefined {
  const params = new URLSearchParams(window.location.search);
  const invitation = params.get('invitation') ?? undefined;
  const organization = params.get('organization') ?? undefined;
  return invitation && organization ? {invitation, organization, prompt: 'login'} : undefined;
}

// Keeps returnTo from re-triggering the invite redirect once login completes.
export function stripInviteParams(path: string): string {
  const url = new URL(path, window.location.origin);
  INVITE_REDIRECT_PARAMS.forEach(param => url.searchParams.delete(param));
  return `${url.pathname}${url.search}${url.hash}`;
}
